var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPaginateFilterVideo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.996582H31V26.9966H5V0.996582Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27 30.9966H3C2.46957 30.9966 1.96086 30.7859 1.58579 30.4108C1.21071 30.0357 1 29.527 1 28.9966V4.99658",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13 9.00017V19.0002C13 19.1771 13.047 19.3509 13.1361 19.5038C13.2253 19.6567 13.3534 19.7832 13.5074 19.8704C13.6614 19.9576 13.8358 20.0023 14.0128 20C14.1897 19.9978 14.3629 19.9486 14.5147 19.8575L22.5147 14.8588C22.6627 14.77 22.7851 14.6443 22.8702 14.4941C22.9552 14.3438 22.9999 14.1741 22.9999 14.0015C22.9999 13.8289 22.9552 13.6592 22.8702 13.5089C22.7851 13.3587 22.6627 13.233 22.5147 13.1442L14.5147 8.1455C14.363 8.05497 14.1902 8.00615 14.0136 8.00398C13.837 8.00181 13.663 8.04638 13.5092 8.13316C13.3554 8.21994 13.2273 8.34585 13.1379 8.49811C13.0485 8.65038 13.0009 8.82359 13 9.00017Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaginateFilterVideo);
export default __webpack_public_path__ + "static/media/PaginateFilterVideo.577eef7e5a213bbde066254ad9ba34e5.svg";
export { ForwardRef as ReactComponent };